var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component_tag,{tag:"component",staticClass:"arrow-text-hover",class:{block: _vm.item_block}},[_c('arrow-right-icon'),_vm._v(" "),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }